import { Injectable, signal } from '@angular/core';

/** The tab bar's room past the end of its pill, in px; `null` while no bar is drawn. */
@Injectable({ providedIn: 'root' })
export class TabBarRoom {
  private readonly trailing = signal<number | null>(null);

  readonly trailingRoom = this.trailing.asReadonly();

  report(room: number | null): void {
    this.trailing.set(room);
  }
}
